module.exports = "https://web-assets.ifttt.com/packs/media/icons/ellipsis-c2ec40b5.png";